import { Link } from "react-router-dom";

export const Logo = ({ size = "md", to = "/" }) => {
  const h = size === "sm" ? "h-8" : size === "lg" ? "h-12" : "h-10";
  return (
    <Link to={to} className="inline-flex shrink-0 items-center" data-testid="clockaroo-logo">
      <img src="/img/logo.png" alt="Clockaroo — In & Out. Sorted" className={`${h} w-auto`} />
    </Link>
  );
};
